import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { enableItemFromSerendipity, disableItemFromSerendipity } from 'modules/serendipity/actions';
import { bindActionCreators } from 'redux';
import SpeedDatingCard from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.speedDatingCard,
    itemsPreferencesFromSerendipity: state.serendipity.preferences,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    enableItemFromSerendipity: bindActionCreators(enableItemFromSerendipity, dispatch),
    disableItemFromSerendipity: bindActionCreators(disableItemFromSerendipity, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpeedDatingCard));



// WEBPACK FOOTER //
// ./src/components/Cards/SpeedDatingSmallCard/container/index.js